import {
  DataSourceTable,
  DataSourceTableSelectItem,
} from 'src/constants/dataSourceTable';

export const dataSourceTableToSelectItem = ({
  name,
  catalog,
  schema,
}: DataSourceTable): DataSourceTableSelectItem => ({
  catalog,
  name,
  schema,
  text: name,
  // Note: value is just for keeping select items unique; this should
  // not be used for generating queries, in part becase quoteCharacter
  // might be overridden by SQL_QUOTING_CONVENTION settings
  value: [catalog, schema, name].filter(Boolean).join('.'),
});
